export default function CurrencyFormat(value) {
  const uang = new Intl.NumberFormat().format(value);
  return uang;
}
